<template>
  <div>
    <v-btn rounded="pill" class="bookmark-btn" @click="playlistModalOpen = true">
      <v-icon class="bookmark-icon">fa-light fa-bookmark</v-icon>
      <span class="bookmark-text d-none d-md-inline">Pievienot izlasei</span>
    </v-btn>
    <UserPlaylistsModal
      :dialog-value="playlistModalOpen"
      :product-data="playlistProductData"
      @close="playlistModalOpen = false"
    />
  </div>
</template>

<script lang="ts">
import { usePdfStore } from "~/stores/pdfStore"

export default {
  setup() {
    const pdfStore = usePdfStore()
    return { pdfStore }
  },

  data() {
    return {
      playlistModalOpen: false,
    }
  },

  computed: {
    playlistProductData() {
      if (this.$route.query.w) {
        return {
          identifier: this.pdfStore.currentFile.worksheet_file.id,
          type: "WorksheetFile",
        }
      } else if (this.pdfStore.currentFile) {
        return {
          identifier: this.pdfStore.currentFile.product.slug,
          type: "Product",
        }
      }
      return {
        identifier: "",
        type: "",
      }
    },
  },
}
</script>
